/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import "./style.scss";
import { CustomInput } from "src/Components";
import { Button } from "src/Components/customInput";

import { ReactComponent as Add } from "src/Assets/Icons/add.svg";
import { ReactComponent as Search } from "src/Assets/Icons/search.svg";
import { ReactComponent as Close } from "src/Assets/Icons/close.svg";
import { GetApi } from "../services/auth";
import { isValid } from "../services/utils";
import showToast from "../services/toastyService";

const baseData = window.globalConfig.BASE_DATA;

export default function RelatorioGeral({ darkMode }) {
  const [vendas, setVendas] = useState([]);
  const [movimentacoes, setMovimentacoes] = useState([]);

  const [showDetalhes, setShowDetalhes] = useState({});

  const [nicchioDolar, setNicchioDolar] = useState({
    saldo: 0,
    cambio: 0,
    total: 0,
  });
  const [nicchioEuro, setNicchioEuro] = useState({
    saldo: 0,
    cambio: 0,
    total: 0,
  });
  const [vixDolar, setVixDolar] = useState({
    saldo: 0,
    cambio: 0,
    total: 0,
  });
  const [vixEuro, setVixEuro] = useState({
    saldo: 0,
    cambio: 0,
    total: 0,
  });

  function formatarValor(valor, moeda = "BRL") {
    if (valor == null || isNaN(valor)) {
      switch (moeda) {
        case "USD":
          return "US$ 0,00";
        case "EUR":
          return "€ 0,00";
        default:
          return "R$ 0,00";
      }
    }

    switch (moeda) {
      case "USD":
        return valor.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
      case "EUR":
        return valor.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
        });
      default:
        return valor.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
    }
  }

  useEffect(() => {
    if (!isValid(vendas)) {
      GetApi("vendas")
        .then((res) => {
          setVendas(res?.data?.vendas);
          showToast("success", res.message);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (!isValid(movimentacoes)) {
      GetApi("cambios")
        .then((res) => {
          setMovimentacoes(res?.data?.cambios);
          showToast("success", res.message);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  function calcularValores(exportador, moeda) {
    const totalAproveitamento = movimentacoes
      .filter(
        (m) =>
          m.Moeda === moeda &&
          m.Modalidade === "Aproveitamento" &&
          m.Exportador === exportador
      )
      .reduce((total, m) => total + (m.Cambio_Contratado || 0), 0);

    const totalACC = movimentacoes
      .filter(
        (m) =>
          m.Moeda === moeda &&
          m.Modalidade === "ACC" &&
          m.Exportador === exportador
      )
      .reduce((total, m) => total + (m.Cambio_Contratado || 0), 0);

    const saldoMovimentacoes = totalAproveitamento - totalACC;

    const saldoBancos = getSaldoBancos(exportador, moeda);

    const saldo = saldoMovimentacoes + saldoBancos;

    const totalVendas = vendas
      .filter((v) => v.Moeda === moeda && v.Exportador === exportador)
      .reduce((total, v) => total + (v.PV || 0) * (v.Quantidade || 0), 0);

    const totalMov = movimentacoes
      .filter(
        (m) =>
          m.Moeda === moeda &&
          m.Exportador === exportador &&
          ["Pronto", "Aproveitamento"].includes(m.Modalidade)
      )
      .reduce((total, m) => total + (m.Cambio_Contratado || 0), 0);

    const cambioSistema = totalVendas - totalMov;
    const cambioBancos = getCambioBancos(exportador, moeda);

    const cambio = cambioSistema + cambioBancos;

    return { saldo, cambio, total: saldo + cambio };
  }

  useEffect(() => {
    setNicchioDolar(calcularValores("Nicchio Café Ltda", "USD"));
    setNicchioEuro(calcularValores("Nicchio Café Ltda", "EUR"));
    setVixDolar(calcularValores("Vix Café Ltda", "USD"));
    setVixEuro(calcularValores("Vix Café Ltda", "EUR"));
  }, [vendas, movimentacoes]);

  function getSaldoBancos(exportador, moeda) {
    const key =
      exportador === "Nicchio Café Ltda"
        ? "nicchio"
        : exportador === "Vix Café Ltda"
          ? "vixport"
          : null;

    if (!key) return 0;

    return (
      baseData?.[key]?.[moeda]?.Bancos?.reduce(
        (total, b) => total - (b.debito || 0),
        0
      ) || 0
    );
  }

  function getCambioBancos(exportador, moeda) {
    const key =
      exportador === "Nicchio Café Ltda"
        ? "nicchio"
        : exportador === "Vix Café Ltda"
          ? "vixport"
          : null;

    if (!key) return 0;

    return baseData?.[key]?.[moeda]?.CambioContratar || 0;
  }

  return (
    <div className="RelatorioGeral">
      {isValid(showDetalhes) && (
        <button
          style={{ zIndex: 5 }}
          className={`-popupFade`}
          onClick={() => setShowDetalhes({})}
        />
      )}
      {isValid(showDetalhes) && (
        <div className="-popup detalhes">
          <div className="content">
            <h5> {showDetalhes.title} </h5>
            <h6> Vendas Com Saldo </h6>
            <p className="header">
              <b>Venda</b>
              Câmbio A Contratar
            </p>
            {vendas
              .filter(
                (venda) =>
                  venda.Exportador === showDetalhes.id &&
                  venda.Moeda === showDetalhes.moeda
              )
              .map((venda) => {
                const valorDaVenda = venda?.PV * venda?.Quantidade;

                const filtrados = movimentacoes.filter(
                  (item) => item?.Venda_id === venda?.Venda_id
                );

                const cambioContratadoTotal = filtrados.reduce(
                  (total, item) => total + (item?.Cambio_Contratado || 0),
                  0
                );

                const cambioAContratar = valorDaVenda - cambioContratadoTotal;

                if (cambioAContratar > 0)
                  return (
                    <p key={venda?.id}>
                      <b>
                        {venda.Exportador === "Nicchio Café Ltda" ? "NV" : "VP"}{" "}
                        - {venda?.NV}
                      </b>
                      {formatarValor(cambioAContratar, venda.Moeda)}
                    </p>
                  );
              })}
          </div>

          <button className="close" onClick={() => setShowDetalhes({})}>
            <Close />
          </button>
        </div>
      )}

      <div className="item">
        <Button
          OnClick={() => {
            setShowDetalhes({
              title: "Nicchio Café - Dólar",
              id: "Nicchio Café Ltda",
              moeda: "USD",
            });
          }}
        >
          Nicchio Café - Dólar
        </Button>
        <p>
          Saldo em Bancos:
          <span>{formatarValor(nicchioDolar.saldo, "USD")}</span>
        </p>
        <p>
          Câmbio a Contratar:
          <span>{formatarValor(nicchioDolar.cambio, "USD")}</span>
        </p>
        <h3>
          TOTAL: <span>{formatarValor(nicchioDolar.total, "USD")}</span>
        </h3>
      </div>
      <div className="item">
        <Button
          OnClick={() => {
            setShowDetalhes({
              title: "Nicchio Café - Euro",
              id: "Nicchio Café Ltda",
              moeda: "EUR",
            });
          }}
        >
          Nicchio Café - Euro
        </Button>
        <p>
          Saldo em Bancos:
          <span>{formatarValor(nicchioEuro.saldo, "EUR")}</span>
        </p>
        <p>
          Câmbio a Contratar:
          <span>{formatarValor(nicchioEuro.cambio, "EUR")}</span>
        </p>
        <h3>
          TOTAL: <span>{formatarValor(nicchioEuro.total, "EUR")}</span>
        </h3>
      </div>
      <div className="item">
        <Button
          OnClick={() => {
            setShowDetalhes({
              title: "Vixport - Dólar",
              id: "Vix Café Ltda",
              moeda: "USD",
            });
          }}
        >
          Vixport - Dólar
        </Button>
        <p>
          Saldo em Bancos: <span>{formatarValor(vixDolar.saldo, "USD")}</span>
        </p>
        <p>
          Câmbio a Contratar:
          <span>{formatarValor(vixDolar.cambio, "USD")}</span>
        </p>
        <h3>
          TOTAL: <span>{formatarValor(vixDolar.total, "USD")}</span>
        </h3>
      </div>
      <div className="item">
        <Button
          OnClick={() => {
            setShowDetalhes({
              title: "Vixport - Euro",
              id: "Vix Café Ltda",
              moeda: "EUR",
            });
          }}
        >
          Vixport - Euro
        </Button>
        <p>
          Saldo em Bancos: <span>{formatarValor(vixEuro.saldo, "EUR")}</span>
        </p>
        <p>
          Câmbio a Contratar:
          <span>{formatarValor(vixEuro.cambio, "EUR")}</span>
        </p>
        <h3>
          TOTAL: <span>{formatarValor(vixEuro.total, "EUR")}</span>
        </h3>
      </div>
    </div>
  );
}
